/**
 * Le back marque `dirty` les messages contenant un mot banni et ne les publie que sur le canal
 * staff. Les participants restent abonnés à ce canal (messages privés), le message leur parvient
 * donc quand même : c'est ici qu'on décide de ne pas l'afficher.
 */
export function isModeratedChatMessage(data: unknown): boolean {
  if (data == null || typeof data !== 'object') return false;
  return (data as { dirty?: unknown }).dirty === true;
}

export type ChatViewer = {
  userId: string;
  isStaff: boolean;
};

/**
 * L'id d'un intervenant vient de son identité LiveKit, pas d'un id de participant : il ne peut
 * reconnaître aucun message comme le sien, il ne voit donc aucun message modéré.
 */
export function chatViewerFromProps({
  userId,
  isAdmin,
  isSpeaker,
}: {
  userId: string;
  isAdmin?: boolean;
  isSpeaker?: boolean;
}): ChatViewer {
  if (isAdmin === true) return { userId, isStaff: true };
  if (isSpeaker === true) return { userId: '', isStaff: false };
  return { userId, isStaff: false };
}

function messageAuthorId(data: object): string | null {
  const { userId, attendeeId } = data as { userId?: unknown; attendeeId?: unknown };
  const authorId = userId ?? attendeeId;
  return typeof authorId === 'number' || typeof authorId === 'string' ? String(authorId) : null;
}

/**
 * Le message modéré d'un participant n'est visible que de son auteur, sans rien lui signaler.
 * Côté staff, `userId` est un id de compte et non de participant : on ne le compare pas.
 */
export function isModeratedChatMessageVisible(data: unknown, viewer: ChatViewer): boolean {
  if (!isModeratedChatMessage(data)) return true;
  const message = data as { teamMember?: unknown };
  if (viewer.isStaff) return message.teamMember === true;
  const authorId = messageAuthorId(data as object);
  return viewer.userId !== '' && authorId === viewer.userId;
}
